import { LOCALES } from "../locales";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [LOCALES.ENGLISH]: {
    //COMMON
    commonBackToTheMainPage: "Back to the main page",
    commonBackToOrganizersPage: "Back to organizers list",
    hideRows: "First 10 rows were hidden",

    //HEADER
    headerDevicesConnected: "Connected to panel",
    headerOptToUsers: "Set user otp",
    headerOpenEvents: "Events",
    headerOpenProfiles: "Profiles",
    headerOpenOrganizers: "Organizers",
    headerOpenOrganizersRequest: "Organizer Requests",
    headerOpenDocuments: "Documents",
    headerOpenTransactions: "Transactions",
    headerOpenMarketingPersons: "Marketing Persons",
    headerOpenStaticOtp: "Static OTP",
    headerOpenOtpBypass: "Captcha bypass",
    headerOpenRobotSmsPolicy: "Robot SMS policy",
    headerTotalMoney: "Total money",
    headerTotalFee: "Total fee",
    headerTransactionTotalFee: "Transaction Fee",
    headerTransactionTotalFastFee: "Fast Transaction Fee",
    headerTransactionTotalEarlyFee: "Early Transaction Fee",
    headerTransactionTotalAdminWithdrawalFee: "Admin Withdrawal Fee",
    headerDownloadReport: "Report",
    headerCancelTicket: "Cancel Ticket",
    headerCancelTicketByUuid: "Cancel Ticket by UUID",

    // SEND OTP MODAL
    otpCode: "User otp code",
    setOtp: "Set otp",
    otpSetSuccess:
      "Otp code mocked for user for next 60 minutes and code copied to your clipboard",
    otpSetFailed: "Otp code failed",
    otpPhoneInvalid: "Invalid phone number",
    otpIsStatic: "Use this OTP permanently",
    otpIsStaticHint:
      "The code never expires. This phone gets no SMS, WhatsApp or Telegram messages and no reCAPTCHA on login.",
    otpSetStaticSuccess:
      "Static otp code set for user, it never expires and was copied to your clipboard",

    // STATIC OTP SCREEN
    staticOtpScreenTitle: "Users with static OTP",
    otpListPhone: "Phone",
    otpListUser: "User",
    otpListNotRegistered: "Not registered yet",
    otpListDeleted: "deleted",
    staticOtpCode: "Code",
    staticOtpSetAt: "Set at",
    staticOtpLastLogin: "Last login",
    otpListActions: "Actions",
    staticOtpRemove: "Remove static OTP",
    staticOtpRemoveConfirm:
      "The code for {phone} will stop working and the next login will send a regular OTP.",
    staticOtpRemoveSuccess: "Static OTP removed",
    staticOtpRemoveFailed: "Failed to remove static OTP",
    staticOtpCodeCopied: "Code copied",
    staticOtpAdd: "Add static OTP",
    staticOtpEdit: "Edit static OTP",
    staticOtpEditButton: "Edit",
    staticOtpSave: "Save",
    staticOtpCodeLabel: "OTP code (6 digits)",
    staticOtpCodeInvalid: "The code must be 6 digits",
    staticOtpGenerateCode: "Generate random code",
    staticOtpUpdateSuccess: "Static OTP updated, the code was copied to your clipboard",
    otpListSearch: "Search by phone, name or email",

    // CAPTCHA BYPASS SCREEN
    otpBypassScreenTitle: "Phones without captcha and OTP limits",
    otpBypassAdd: "Add phone",
    otpBypassHint:
      "This phone still gets a real code by SMS, WhatsApp or Telegram, but skips reCAPTCHA, OTP request limits and blocks.",
    otpBypassAddedAt: "Added at",
    otpBypassActive: "Active",
    otpBypassAddSuccess: "Phone added",
    otpBypassAddFailed: "Failed to add phone",
    otpBypassUpdateFailed: "Failed to update phone",
    otpBypassRemove: "Remove",
    otpBypassRemoveConfirm: "{phone} will go back to the regular captcha and OTP limits.",
    otpBypassRemoveSuccess: "Phone removed",
    otpBypassRemoveFailed: "Failed to remove phone",

    // ROBOT SMS POLICY SCREEN
    robotSmsPolicyTitle: "Robot SMS - custom lists declaration",
    robotSmsPolicyHint:
      "Organizers read and accept the active version before they upload their own recipient lists. A new upload becomes the active version right away and every organizer has to accept it again. Versions can't be deleted - disable the ones that must not be used.",
    robotSmsPolicyActiveSummary: "Active version: {version} · accepted by {count}",
    robotSmsPolicyUpload: "Upload new version",
    robotSmsPolicyVersion: "Version",
    robotSmsPolicyStatus: "Status",
    robotSmsPolicyStatusActive: "Active",
    robotSmsPolicyStatusDisabled: "Disabled",
    robotSmsPolicyStatusAvailable: "Not active",
    robotSmsPolicyFile: "File",
    robotSmsPolicyOpen: "Open PDF",
    robotSmsPolicyUploaded: "Uploaded",
    robotSmsPolicyActivatedAt: "Active since",
    robotSmsPolicyAccepted: "Accepted by",
    robotSmsPolicyActions: "Actions",
    robotSmsPolicyMakeActive: "Make active",
    robotSmsPolicyDisable: "Disable",
    robotSmsPolicyEnable: "Enable",
    robotSmsPolicyActiveCantDisable: "The active version can't be disabled - make another version active first",
    robotSmsPolicyActivateConfirm:
      "Make version {version} active? Organizers who haven't accepted this version will have to read and accept it before using their lists.",
    robotSmsPolicyActivateSuccess: "Version {version} is active",
    robotSmsPolicyUpdateFailed: "Failed to update the version",
    robotSmsPolicyUploadTitle: "Upload new policy version",
    robotSmsPolicyVersionLabel: "Version, for example 1.1",
    robotSmsPolicyVersionInvalid: "Only letters, digits, \".\", \"-\" and \"_\", up to 32 characters",
    robotSmsPolicyVersionExists: "This version already exists",
    robotSmsPolicyDrop: "Drop the PDF here or click to choose it",
    robotSmsPolicyFileHint: "PDF only, up to 20 MB",
    robotSmsPolicyFileInvalid: "Choose a PDF file up to 20 MB",
    robotSmsPolicyUploadWarning:
      "The uploaded file becomes the active version right away. Every organizer will have to read and accept it again before using their lists.",
    robotSmsPolicyUploadSubmit: "Upload and make active",
    robotSmsPolicyUploadSuccess: "Version {version} is uploaded and active",
    robotSmsPolicyUploadFailed: "Failed to upload the file",
    robotSmsPolicyTabVersions: "Document versions",
    robotSmsPolicyTabDeclarations: "Signed declarations",
    robotSmsAutoApprove: "Auto-approve declarations",
    robotSmsAutoApproveOnHint: "On: organizers can upload their lists right after signing. Turn it off to approve every declaration manually.",
    robotSmsAutoApproveOffHint: "Off: every signed declaration waits for your approval. The organizer gets a notification about your decision.",
    robotSmsAutoApproveOn: "Auto-approve is on",
    robotSmsAutoApproveOff: "Auto-approve is off - new declarations wait for approval",
    robotSmsDeclarationStatusAll: "All",
    robotSmsDeclarationStatus_pending: "Pending review",
    robotSmsDeclarationStatus_approved: "Approved",
    robotSmsDeclarationStatus_rejected: "Rejected",
    robotSmsDeclarationStatus_revoked: "Access revoked",
    robotSmsDeclarationSearch: "Search by name, ID, business, email or phone",
    robotSmsDeclarationSignedAt: "Signed",
    robotSmsDeclarant: "Declarant",
    robotSmsDeclarationBusiness: "Business",
    robotSmsDeclarationContacts: "Contacts",
    robotSmsDeclarationReview: "Review",
    robotSmsDeclarationOpen: "Open",
    robotSmsDeclarationTitle: "Signed declaration",
    robotSmsDeclarationIdNumber: "ID number",
    robotSmsDeclarationRegistrationNumber: "Company / dealer number",
    robotSmsDeclarationDataSource: "Source of the data",
    robotSmsDeclarationAccount: "Selector account",
    robotSmsDeclarationReviewed: "Reviewed",
    robotSmsDeclarationAuto: "automatically",
    robotSmsDeclarationReason: "Reason: {reason}",
    robotSmsDeclarationIdPhoto: "ID photo",
    robotSmsDeclarationSignature: "Signature",
    robotSmsDeclarationOpenFile: "Open file",
    robotSmsDeclarationLinksHint: "Files are private. Links work for 10 minutes - reopen the declaration to get new ones.",
    robotSmsDeclarationReasonLabel: "Reason",
    robotSmsDeclarationReasonHint: "The organizer will see this text",
    robotSmsDeclarationClose: "Close",
    robotSmsDeclarationRestore: "Restore access",
    robotSmsDeclarationAction_approve: "Approve",
    robotSmsDeclarationAction_reject: "Reject",
    robotSmsDeclarationAction_revoke: "Revoke access",
    robotSmsDeclarationAction_approve_success: "Approved - the organizer got a notification",
    robotSmsDeclarationAction_reject_success: "Rejected - the organizer got a notification",
    robotSmsDeclarationAction_revoke_success: "Access revoked - the organizer got a notification",

    //DEVICES MODAL
    devicesModalTitle: "Active Devices",
    otpModalTitle: "Set user otp",
    robotCreditsModalTitle: "Change user robot sms credits",
    devicesModalActionDisconnectSuccess: "Device disconnect success",
    devicesModalActionDisconnectFailure: "Device disconnect error",

    //ADD PAYMENT MODAL
    apModalTitle: "Add new payment",
    apModalDropFileHere: "Drop file here",
    apModalDragFileHere: "Drag file here",
    apModalUploadFile: "UPLOAD FILE",
    apModalReUploadFile: "REUPLOAD FILE",

    //FILTER
    filterTitle: "FILTER",
    filterItemOnlyPaid: "Only paid",
    filterItemSortByName: "Sort by name",
    filterItemAscending: "Ascending",
    filterSubmit: "SUBMIT",
    filterRestore: "RESTORE",
    filterSearch: "Search...",
    filterSearchEventsHint: "Search: name, id:123, link:abc",
    filterSearchUsersHint: "Search: name/surname, phone, id:123",
    filterSearchOrganizersHint: "Search: name/surname, phone, id:123",

    //CUSTOM DATE RANGE PICKER
    cdrpFrom: "From...",
    cdrpTo: "To...",

    //CUSTOM DATAGRID
    customDataGridLoadMore: "LOAD MORE",

    // EVENTS STATUS NAV
    esnWaitingForConfirm: "Waiting for confirm",
    esnDeletedEvents: "Deleted",
    esnFinishedEvents: "Finished",
    esnFinishedUnpaidEvents: "Unpaid",
    esnHiddenEvents: "Hidden",
    esnAllEvents: "All",
    esnActiveEvents: "Active",
    esnCanceledEvents: "Canceled",
    esnInProgressEvents: "In Progress",
    esnCurrentWeekEvents: "Current week",

    //PROFILES
    gridProfilesTotalClearances: "Total clearances",
    gridProfilesTotalPurchases: "Total purchases",
    gridProfilesAmountOfPurchasedTickets: "Amount of tickets purchased",
    gridProfilesAmountOfEvents: "Amount of events",
    gridProfilesProducerAndIdentityCardOrHPAndPhoneNumber:
      "Producer information",
    gridProfilesCreatorOfTheEvent: "Creator of the event",
    gridProfilesPostalCode: "Postal code",
    gridProfilesCellphoneNumber: "Cellphone number",
    gridProfilesLinkToProfile: "Link to profile",
    gridProfilesDeletedUser: "Deleted user",
    gridProfilesChangeRobotSmsCredits: "Change Robot SMS Credits",
    gridProfilesChangeRobotSmsCreditsCount: "Robot SMS Credits:",
    gridProfilesChangeRobotSmsAccess: "Robot SMS",
    gridProfilesRestoreUser: "Restore user",
    gridProfilesAutoConfirmationUser: "Auto Confirmation",

    buttonDownloadAllInformation: "Download all information",
    profilesDeletedProfiles: "Deleted profiles",
    profilesAllProfiles: "All profiles",
    profilesTotalCreditsCountL: "Robot Sms Total Credits:",

    //ALL EVENTS
    gridEventsOpenAsOwner: "Open as owner",
    gridEventsPaymentStatus: "Payment Status",
    gridEventsPaymentStatusIsPaidCheckBox: "Paid",
    gridEventsOrderConfirmation: "Order Confirmation",
    gridEventsFile: "File",
    gridEventsReceiptFile: "Receipt file",
    gridEventsInvoiceFile: "Invoice file",
    gridEventsBankAccountInfo: "Bank account info",
    gridEventsBankAccountInfoNumber: "Branch number",
    gridEventsBankAccountInfoAccountNumber: "Account number",
    gridEventsBankAccountFullName: "Full name",
    gridEventsTotalCommisionProfit: "Total commission profit",
    gridEventsTotalTicketsPurchasedInCredit: "Total money without fee",
    gridEventsTotalTicketsSold: "Total tickets sold",
    gridEventsTotalTicketsSoldInCredit: "Total tickets sold in credit",
    gridEventsCanceledMoney: "Canceled money",
    gridEventsCanceledCount: "Canceled count",
    gridEventsReturnedMoney: "Returned money",
    gridEventsReturnedCount: "Returned count",
    gridEventsProducerAndIdentityCardOrHPAndPhoneNumber: "Producer info",
    gridEventsCreatorName: "Full name",
    gridEventsCreatorAddress: "Address",
    gridEventsCreatorPhone: "Phone number",
    gridEventsStartDate: "Date of start",
    gridEventsCreateDate: "Date of creation",
    gridEventsName: "Event name",
    gridEventsStatus: "Event status",
    gridEventsStatusDeleted: "DELETED",
    gridEventsStatusHidden: "HIDDEN",
    gridEventsStatusHighPriority: "HIGH PRIORITY",
    gridEventsRepeatEvent: "REPEAT EVENT",
    gridEventsShowEvent: "SHOW EVENT",
    gridEventsConfirmEvent: "CONFIRM EVENT",
    gridEventsDeleteEvent: "DELETE EVENT",

    //TRANSACTIONS
    invoiceTotalInvoicesBeforeVAT: "Total invoices before VAT",
    invoiceTotalVAT: "Total VAT",
    invoiceTotalInvoicesIncluded: "Total invoices included",
    invoiceThisEventHasNoSuchFiles: "This event has no such files",
    transactionsInvoices: "Invoices",
    transactionsConfirm: "Confirms",
    transactionsCancelled: "Canceled",
    transactionsFetchError: "An error occurred while loading the page",

    //LOGIN
    loginEnterNumber: "ENTER YOUR PHONE NUMBER HERE",
    loginSendCode: "SEND CODE VIA SMS",
    loginEnterCode: "ENTER YOUR OTP CODE HERE",
    loginVerifyCode: "VERIFY OTP CODE",
    loginCodeSendSuccess: "OTP sended successfully!",
    loginCodeInvalid: "Invalid code!",
    loginError: "ERROR!",

    organizersAllOrganizers: "All",
    organizersActiveOrganizers: "Active",
    organizersNotActiveOrganizers: "Not Active",

    organizersTotalCount: "Total Organizers count:",
    organizersButtonDownloadExcel: "Download Excel",
    organizersButtonDownloadShortExcel: "Download short info",

    gridOrganizersOrganizerInfo: "Organizer Info",
    gridOrganizersName: "Full name:",
    gridOrganizersPhone: "Phone:",
    gridOrganizersEmail: "Email:",
    gridOrganizersIDcode: "ID Code:",

    gridOrganizersOrganizerEventsInfo: "Events Info",
    gridOrganizersTotalEventsCount: "Total Events:",
    gridOrganizersActiveEventsCount: "Active Events:",
    gridOrganizersFinishedEventsCount: "Finished Events:",
    gridOrganizersCancelledEventsCount: "Cancelled Events:",
    gridOrganizersPendingEventsCount: "Pending Events:",

    gridOrganizersOrganizerEventsActivityInfo: "Events Activity Info",
    gridOrganizersTotalTicketsSoldCount: "Total Tickets Count:",
    gridOrganizersTotalTicketsSoldMoney: "Total Tickets Money:",
    gridOrganizersTotalTicketsSoldFee: "Total Tickets Fee:",
    gridOrganizersActivePeriodTotalTicketsSoldCount: "Last 60d Tickets Count:",
    gridOrganizersActivePeriodTotalTicketsSoldMoney: "Last 60d Tickets Money:",
    gridOrganizersActivePeriodTotalTicketsSoldFee: "Last 60d Tickets Fee:",

    gridOrganizersOrganizerActivityInfo: "Activity Info",
    gridOrganizersJoinDate: "Join Date:",
    gridOrganizersLastEventDate: "Last Event Date:",
    gridOrganizersStatus: "Status:",
    gridOrganizersStatusActive: "Active 😊",
    gridOrganizersStatusNotActive: "Not Active 🤔",

    gridOrganizersSettings: "Settings",
    gridOrganizersChangeRobotSmsCreditsCount: "Robot SMS Credits:",
    gridOrganizersChangeRobotSmsCredits: "Change Robot SMS Credits",
    gridOrganizersChangeRobotSmsAccess: "Robot SMS",
    gridOrganizersAutoConfirmationUser: "Auto Confirmation",
    gridOrganizersHideEventsFromMain: "Hide events from main page",

    // Other
    changeUserCredits: "Update user robot sms credits",
    updateCreditsError: "Error. Try again please.",

    onlyUnpaidEventsFlagText: "Output only unpaid events",
    downloadReportModalTitle: "Download events report",
    ignoreYeshInvoiceText: "Ignore YeshInvoice",
    ignoreTransactionsText: "Ignore Transactions",
    ignoreZCreditText: "Ignore ZCredit",
    downloadReportFromDate: "From Date",
    downloadReportToDate: "To Date",
    downloadReport: "Download report",
    downloadReportError: "Error when trying download report",

    cancelTicketModalTitle: "Cancel ticket",
    phoneNumberPlaceholder: "Phone number",
    eventLinkPlaceholder: "Event Link",
    searchTickets: "Search Tickets",
    backToSearch: "Back to search",
    buyerUser: "Buyer User",
    ticketUser: "Ticket User",
    ticketInfo: "Ticket Info",
    price: "Price",
    feePrice: "Fee",
    cardHolder: "Card Holder",
    cardNumber: "Card Number",
    ticketStatus: "Change ticket status",
    returnMoney: "Return money (ZCredit)",
    sendSms: "Send sms",
    yeshInvoiceDocs: "Generate YeshInvoice documents",
    fullReturn: "Full return money (with fee)",
    changeTicketStatus: "Change tickets",
    backToList: "Back to list",
    ticketChangedSuccess: "Tickets status success changed",
    cancelTicketByUuidModalTitle: "Cancel ticket by UUID",
    sessionIdPlaceholder: "Session UUID",
    cancelTicketByUuidSubmit: "Cancel tickets",
    continue: "Continue",
    existDocumentSkip: "Skip existing document check (allow re-run)",

    organizerSettingsAdminNote: "Admin note about organizer",
    organizerSettingsModalTitle: "Update organizer settings",
    organizerFreeTransactionCount: "Free Transaction Count",
    organizerTransactionFee: "Transaction Fee",
    organizerFastWithdrawalFee: "Fast Withdrawal Fee",
    organizerTransactionMinSum: "Transaction Min Sum",
    organizerEarlyWithdrawalEnabled: "Early Withdrawal",
    organizerEarlyWithdrawalPercent: "Early Withdrawal Percent",
    organizerEarlyWithdrawalDays: "Early Withdrawal Days",
    organizerEarlyWithdrawalFee: "Early Withdrawal Fee",
    organizerWithdrawalTypeDefault: "Default",
    organizerWithdrawalTypeDays: "By Days",
    organizerWithdrawalDays: "Withdrawal Days",
    organizerUpdateSettings: "Update Settings",
    organizerFreeTransactionCountMinError: "Free transaction minimum count 0",
    organizerFreeTransactionCountRequiredError:
      "Free transaction count is required",
    organizerTransactionFeeMinError: "Transaction fee minimum is 0",
    organizerTransactionFeeRequiredError: "Free transaction fee is required",
    organizerFastWithdrawalFeeMinError: "Fast withdrawal fee minimum is 0",
    organizerFastWithdrawalFeeRequiredError: "Fast withdrawal fee is required",
    organizerTransactionMinSumMinError: "Transaction minimum sum is 0",
    organizerTransactionMinSumRequiredError:
      "Free transaction minimum sum is required",
    organizerEarlyWithdrawalPercentMinError: "Transaction minimum percent is 0",
    organizerEarlyWithdrawalPercentMaxError:
      "Transaction maximum percent is 100",
    organizerEarlyWithdrawalPercentRequiredError:
      "Early withdrawal percent is required",
    organizerEarlyWithdrawalDaysMinError: "Early withdrawal days minimum -365",
    organizerEarlyWithdrawalDaysMaxError: "Early withdrawal days maximum 365",
    organizerEarlyWithdrawalDaysRequiredError:
      "Early withdrawal days is required",
    organizerEarlyWithdrawalFeeMinError:
      "Early withdrawal fee minimum percent is 0",
    organizerEarlyWithdrawalFeeMaxError:
      "Early withdrawal fee maximum percent is 100",
    organizerEarlyWithdrawalFeeRequiredError:
      "Early withdrawal fee is required",
    organizerWithdrawalDaysMinError: "Withdrawal days minimum is 0",
    organizerWithdrawalDaysRequiredError: "Withdrawal days is required",

    transactionAll: "All",
    transactionPending: "Pending",
    transactionWithdrawn: "Withdrawn",
    transactionRejected: "Rejected",
    transactionCancelled: "Cancelled",
    transactionInProgress: "In Progress",
    transactionFast: "Fast",

    showTransactions: "Show Transactions",

    gridEventTransactionListTransactionNameInfo: "Common Info",
    gridEventTransactionListTransactionName: "Transaction Name",
    gridEventTransactionListTransactionDescription: "Transaction Note",
    gridEventTransactionListTransactionAdminDescription:
      "Transaction Admin Note",
    gridEventTransactionListTransactionAdminComment: "Admin Comment",
    gridEventTransactionListAddAdminComment: "Add comment",
    gridEventTransactionListEditAdminComment: "Edit comment",
    gridEventTransactionListDeleteAdminComment: "Delete comment",
    adminCommentPlaceholder: "Type your comment",
    adminCommentEmptyError: "Comment cannot be empty",
    adminCommentVisibilityHint: "This comment is only visible to admins in the admin panel.",
    saveAdminComment: "Save",
    gridEventTransactionListAddAdminNote: "Add admin note",
    gridEventTransactionListEditAdminNote: "Edit admin note",
    gridEventTransactionListDeleteAdminNote: "Delete admin note",
    adminNoteEmptyError: "Admin note cannot be empty",
    adminNoteVisibilityHint: "This admin note is shown to the organizer and included in the PDF document.",
    saveAdminNote: "Save",

    gridEventTransactionListEventInfo: "Event Info",
    gridEventTransactionListEventName: "Event Name",
    gridEventTransactionListEventStartDate: "Event Start Date",
    gridEventTransactionListEventEndDate: "Event End Date",
    gridEventTransactionListEventShowInfo: "Show Info",

    gridEventTransactionListOrganizerInfo: "Organizer Info",
    gridEventTransactionListOrganizerName: "Full Name",
    gridEventTransactionListOrganizerPhone: "Phone",
    gridEventTransactionListShowOrganizerInfo: "Show Info",

    gridEventTransactionListTransactionInfo: "Transaction Info",
    gridEventTransactionListItemLastTransaction: "Last Event Transaction",
    gridEventTransactionListItemFastWithdrawal: "Fast Withdrawal",
    gridEventTransactionListItemEarlyWithdrawal: "Early Withdrawal",
    gridEventTransactionListItemTotal: "Total Amount",
    gridEventTransactionListItemAmount: "Withdrawal Amount",
    gridEventTransactionListItemFee: "Transaction Fee",
    gridEventTransactionListItemEarlyFee: "Early Withdrawal Fee",
    gridEventTransactionListItemFastFee: "Fast Withdrawal Fee",

    gridEventTransactionListBillAccountInfo: "Bank Account Info",
    gridEventTransactionListBillAccountName: "Name",
    gridEventTransactionListBillAccountDescription: "Description",
    gridEventTransactionListBillAccountHolderName: "Holder Full Name",
    gridEventTransactionListBillAccountBankName: "Bank Name",
    gridEventTransactionListBillAccountBankNumber: "Bank Number",
    gridEventTransactionListBillAccountBankAccountNumber: "Bank Account Number",
    gridEventTransactionListBillAccountIdCode: "ID Code",

    gridEventTransactionListTransactionDates: "Transaction Dates",
    gridEventTransactionListRequestDate: "Request Date",
    gridEventTransactionListLastChangeDate: "Last Change Date",
    gridEventTransactionListStatus: "Status",
    gridEventTransactionListStatusWithdrawn: "Withdrawn",
    gridEventTransactionListStatusPending: "Pending",
    gridEventTransactionListStatusRejected: "Rejected",
    gridEventTransactionListStatusCancelled: "Cancelled",

    gridEventTransactionListActions: "Actions",
    gridEventTransactionListMoveToInProgressTransaction: "Move to In Progress",
    gridEventTransactionListInProgress: "Transaction In Progress",
    gridEventTransactionListApproveTransaction: "Approve Transaction",
    gridEventTransactionListDeclineTransaction: "Decline Transaction",
    gridEventTransactionListDownloadTransactionReceiptPdf:
      "Download Withdrawal Document Pdf",
    gridEventTransactionListDownloadTransactionFeePdf: "Download Fee Pdf",
    gridEventTransactionListDownloadTransactionEarlyWithdrawalFeePdf:
      "Download Early Fee Pdf",
    gridEventTransactionListDownloadTransactionFastWithdrawalFeePdf:
      "Download Fast Fee Pdf",

    gridOrganizerRequestListRequestInfo: "Request Info",
    gridOrganizerRequestListRequestMessage: "Request Message",
    gridOrganizerRequestListRequestDate: "Request Date",
    gridOrganizerRequestListActions: "Actions",
    gridOrganizerRequestListApproveRequest: "Approve Request",
    gridOrganizerRequestListDeclineRequest: "Decline Request",

    approveTransaction: "Approve Transaction",
    declineTransaction: "Decline Transaction",
    adminNotePlaceholder: "Leave admin note",
    approveRequest: "Approve Request",
    declineRequest: "Decline Request",
    cancel: "Cancel",

    gridEventsCrossQRScanner: "Show QR settings",
    eventCrossQRScannerModalTitle: "Update Event Cross QR Scanner Settings",
    relatedEventLink: "Related event link",
    addRelatedScannerEvent: "Add one more",
    updateRelatedScannerEvent: "Update event QR Scanner settings",
    relatedEventLinkRequiredError: "Related event link is required",
    relatedEventsSuccessUpdated: "Related events success updated",

    usersRequiredError: "This field is required",
    usersFormatError:
      "Each line must be in the format: phone,name,surname[,count[,IDcode]]",
    usersColumnsCountError: "Line {n}: expected next phone,name,surname",
    usersPhoneRequiredError: "Line {n}: phone is required",
    usersPhoneInvalidError: "Line {n}: invalid phone number",
    usersNameRequiredError: "Line {n}: first name is required",
    usersSurnameRequiredError: "Line {n}: last name is required",
    usersCountInvalidError: "Line {n}: count must be a positive integer",
    usersIdCodeInvalidError: "Line {n}: ID code contains invalid characters",
    smsRequiredError: "SMS Text is required",
    smsTextMustContainTicketLinkError: "SMS text must include %LINK_TO_TICKET%",

    giftNoneOption: "None",
    gridEventsGiftTickets: "Gift tickets",
    ticketsSuccessGifted: "Ticket success gifted",
    eventGiftTicketsModalTitle: "Gift tickets",
    giftUsersHelper: "Line format: phone,name,surname,count,IDcode",
    giftUsers: "Users for gift",
    giftSmsTextHelper:
      "For sms text need required variable %LINK_TO_TICKET% and optional %EVENT_NAME%",
    giftSmsText: "Sms text",
    giftTicketHelper:
      'You can select from exist ticket or add name (ticket created auto for list of users), default name "כרטיס מתנה לאירוע"',
    giftTicketSelect: "Select ticket (optional)",
    giftTicketName: "Ticket name (optional)",
    giftTickets: "Gift tickets",

    gridEventsChangeOwner: "Change owner",
    changeEventStatusLabel: "Change status",
    changeEventStatusSuccess: "Event status changed",
    changeEventStatusError: "Failed to change event status",
    gridEventsSettings: "Settings",
    eventSettingsModalTitle: "Event settings",
    eventSettingsSectionStatus: "Event status",
    eventSettingsSectionBaseLink: "Base link",
    eventSettingsBaseLinkHelper: "Letters, digits, '_' and '-' only. Must be unique across all events.",
    eventSettingsBaseLinkTakenError: "This link is already taken",
    eventSettingsBaseLinkInvalidError: "Invalid link format",
    eventSettingsBaseLinkAvailable: "Link is available",
    eventSettingsLinksInfo: "Every link that opens this event. After a link is changed, the old address keeps working — links already shared (SMS, ads, social) still open the event. Remove an old link to switch it off or free it for another event.",
    eventSettingsLinkPrevious: "Old links that still work:",
    eventSettingsLinkPreviousDeleteConfirm: "Remove this old link? It will stop opening the event.",
    eventSettingsLinkPreviousDeleted: "Old link removed",
    eventSettingsLinksEmpty: "This event has no links",
    eventSettingsLinksSearch: "Search by link, name or phone",
    eventSettingsLinkLabel: "Short link",
    eventSettingsLinkSave: "Save link",
    eventSettingsLinkSuccess: "Link updated",
    eventSettingsLinkOther: "Additional link",
    eventSettingsLinkReferral: "Referral link",
    eventSettingsLinkPersonal: "Personal link",
    eventSettingsLinkDeleted: "Deleted",
    eventSettingsTabCommon: "Common",
    eventSettingsTabLinks: "Event links",
    eventSettingsTabOwner: "Change owner",
    eventSettingsSaveStatus: "Save status",

    headerManageEventTypes: "Event types",
    eventTypesModalTitle: "Event types",
    eventTypesTabAll: "All",
    eventTypesTabDashboard: "Dashboard",
    eventTypesTranslationEn: "Title (EN)",
    eventTypesTranslationHe: "Title (HE)",
    eventTypesShowInDashboard: "Dashboard",
    eventTypesOrder: "Order",
    eventTypesDashboardOrder: "Dashboard order",
    eventTypesApply: "Apply",
    eventTypesApplySuccess: "Event types updated",
    eventTypesApplyError: "Failed to update event types",
    eventTypesOtpSent: "OTP sent to your Telegram",
    eventTypesOtpModalTitle: "Confirm changes",
    eventTypesOtpModalDescription: "Enter the OTP code sent to your Telegram to apply the changes",
    eventTypesOtpConfirm: "Confirm",
    eventTypesOtpResend: "Resend OTP",
    eventTypesTabDeleted: "Deleted",
    eventTypesAdd: "Add type",
    eventTypesNew: "New",
    eventTypesDelete: "Delete",
    eventTypesRestore: "Restore",
    eventTypesDeleteConfirm: "Delete this event type? It will disappear from event creation, filters, the dashboard and the banner. Existing events will keep it.",
    eventTypesDeletedEmpty: "No deleted event types",
    eventTypesTitleRequiredError: "Enter the title in English and Hebrew",
    eventTypesTitleEnLatinError: "The English title must contain latin letters or digits",
    eventTypesDuplicateError: "An event type with this title already exists",
    eventTypesDuplicateDeletedError: "This event type is among the deleted ones. Restore it instead of creating a new one",
    eventsScreenChangeOwnerByLink: "Change owner by link",
    changeOwnerByLinkModalTitle: "Change event owner by link",
    changeOwnerByLinkFieldLabel: "Event link, URL or event id",
    changeOwnerByLinkFieldHelper: "Paste short link (11 chars), event URL or numeric event id",
    changeOwnerByLinkFieldRequiredError: "Event link is required",
    changeOwnerByLinkFieldInvalidFormatError: "Enter a valid event id, short link or event URL",
    changeOwnerByLinkFieldInvalidIdError: "Event id must be a positive number",
    changeOwnerByLinkLookup: "Find event",
    changeOwnerByLinkNotFound: "Event not found by this link",
    changeEventOwnerModalTitle: "Change event owner",
    changeEventOwnerCurrentOwner: "Current owner",
    changeEventOwnerSearchLabel: "Search new owner",
    changeEventOwnerSearchHelper: "Name / surname / phone. For ID lookup use id:123",
    changeEventOwnerNewOwner: "New owner",
    changeEventOwnerNoOwnerSelected: "Select a new owner",
    changeEventOwnerKeepOldOwner: "Keep current owner as editor with owner permissions",
    changeEventOwnerSendOtp: "Send OTP",
    changeEventOwnerResendOtp: "Resend OTP",
    changeEventOwnerConfirm: "Confirm change",
    changeEventOwnerOtpSent: "OTP sent to your Telegram",
    changeEventOwnerOtpLabel: "OTP code",
    changeEventOwnerSuccess: "Event owner changed",
    changeEventOwnerError: "Failed to change event owner",
    changeEventOwnerConfirmModalTitle: "Confirm change owner",
    changeEventOwnerConfirmModalDescription: "Enter the OTP code sent to your Telegram to confirm the owner change",
    confirmActionOtpConfirm: "Confirm",
    confirmActionOtpResend: "Resend OTP",

    sendPushNotificationTitle: "Push notifications",
    sendPushNotificationTabCustom: "Custom",
    sendPushNotificationTabDocs: "Documents updated",
    sendPushNotificationCustomHelper: "You can use %USER_NAME% inside the text — it will be replaced with the recipient's full name.",
    sendPushNotificationDocsHelper: "Text is loaded from the server and will be sent as-is in the recipient's language.",
    sendPushNotificationTitleEn: "Title (EN)",
    sendPushNotificationTitleHe: "Title (HE)",
    sendPushNotificationTextEn: "Text (EN)",
    sendPushNotificationTextHe: "Text (HE)",
    sendPushNotificationAudience: "Audience",
    sendPushNotificationAudience_allOrganizers: "All organizers",
    sendPushNotificationAudience_activeOrganizers: "Active organizers",
    sendPushNotificationAudience_notActiveOrganizers: "Not active organizers",
    sendPushNotificationAudience_allUsers: "All users",
    sendPushNotificationTestCheckbox: "Send test notification (single user by phone)",
    sendPushNotificationTestPhoneLabel: "Recipient phone",
    sendPushNotificationTestPhoneRequired: "Recipient phone is required",
    sendPushNotificationTestUserNameLabel: "Test user name",
    sendPushNotificationTestUserNameHelper: "Used to substitute %USER_NAME% in the test message",
    sendPushNotificationTestUserNameRequired: "Test user name is required when the text uses %USER_NAME%",
    sendPushNotificationValidationTitleTextRequired: "Title and text are required",
    sendPushNotificationSend: "Send",
    sendPushNotificationSendTest: "Send test",
    sendPushNotificationOtpSent: "OTP sent to your Telegram",
    sendPushNotificationTestSuccess: "Test notification sent",
    sendPushNotificationSendStarted: "Notification broadcast started",
    sendPushNotificationOtpModalTitle: "Confirm push send",
    sendPushNotificationOtpModalDescription: "Enter the OTP code sent to your Telegram to confirm the broadcast",

    // SMS BROADCAST (header)
    sendSmsBroadcastTitle: "SMS broadcast",
    sendSmsTabOrganizers: "Organizers",
    sendSmsIsraeliOnlyRemark: "SMS can be sent only to Israeli numbers (+972)",
    sendSmsIsraeliOnly: "SMS can only be sent to Israeli numbers (+972)",
    sendSmsHelperFreeText: "Free text — write EN and/or HE. Each recipient will get the version that matches their profile language.",
    sendSmsHelperUserName: "Tip: use %USER_NAME% in the text to personalize the SMS — it will be replaced with each recipient's name.",
    sendSmsTextEn: "Text (EN)",
    sendSmsTextHe: "Text (HE)",
    sendSmsAudience: "Audience",
    sendSmsAudience_allOrganizers: "All organizers",
    sendSmsAudience_activeOrganizers: "Active organizers",
    sendSmsAudience_notActiveOrganizers: "Not active organizers",
    sendSmsTestCheckbox: "Send test SMS (single user by phone)",
    sendSmsTestPhoneLabel: "Recipient phone (+972 only)",
    sendSmsTestPhoneRequired: "Recipient phone is required",
    sendSmsTestUserNameLabel: "Test user name",
    sendSmsTestUserNameHelper: "Used to substitute %USER_NAME% in the test message",
    sendSmsTestUserNameRequired: "Test user name is required when the text uses %USER_NAME%",
    sendSmsValidationTextRequired: "SMS text is required",
    sendSmsSend: "Send SMS",
    sendSmsSendTest: "Send test SMS",
    sendSmsOtpSent: "OTP sent to your Telegram",
    sendSmsTestSuccess: "Test SMS sent",
    sendSmsBroadcastStarted: "SMS broadcast started",
    sendSmsOtpModalTitle: "Confirm SMS send",
    sendSmsOtpModalDescription: "Enter the OTP code sent to your Telegram to confirm the SMS send",

    // EVENT SMS TAB
    eventSettingsTabSms: "SMS",
    eventSmsTabDescription: "Send SMS related to this event. All actions require OTP confirmation.",
    eventSmsIsraeliOnlyRemark: "SMS can be sent only to Israeli numbers (+972)",
    eventSmsKind_resendBuyers_title: "Resend SMS to ticket buyers",
    eventSmsKind_resendBuyers_description: "Re-sends the confirmation SMS (tickets + receipt links) to everyone who bought a ticket.",
    eventSmsKind_resendBuyers_tooltip: "Iterates over unique buyers of confirmed tickets and resends the standard confirmation SMS. No custom text required.",
    eventSmsKind_notifyHolders_title: "Send SMS to ticket holders",
    eventSmsKind_notifyHolders_description: "Sends a reminder SMS to everyone who holds a ticket (may differ from the buyer for gifted tickets).",
    eventSmsKind_notifyHolders_tooltip: "Includes the event name, date and the recipient's tickets link.",
    eventSmsKind_customBuyers_title: "Send custom SMS to ticket buyers",
    eventSmsKind_customBuyers_description: "Type your own SMS text. Variables will be replaced per recipient.",
    eventSmsKind_customBuyers_tooltip: "Sent to buyers of confirmed tickets. Israeli numbers only.",
    eventSmsKind_customHolders_title: "Send custom SMS to ticket holders",
    eventSmsKind_customHolders_description: "Type your own SMS text. Variables will be replaced per recipient.",
    eventSmsKind_customHolders_tooltip: "Sent to ticket holders (ticketUser). Israeli numbers only.",
    eventSmsVariablesHelp: "Available variables: %USER_NAME%, %EVENT_NAME%, %EVENT_DATE%, %LINK_TO_TICKET%",
    eventSmsTextEn: "SMS text (EN)",
    eventSmsTextHe: "SMS text (HE)",
    eventSmsSend: "Send",
    eventSmsValidationTextRequired: "SMS text is required for custom SMS",
    eventSmsOtpSent: "OTP sent to your Telegram",
    eventSmsBroadcastStarted: "Event SMS broadcast started",
    eventSmsOtpModalTitle: "Confirm event SMS",
    eventSmsOtpModalDescription: "Enter the OTP code sent to your Telegram to confirm the send",
    eventSmsTestCheckbox: "Send test SMS (single phone number)",
    eventSmsTestPhoneLabel: "Test phone (+972 only)",
    eventSmsTestPhoneRequired: "Test phone is required",
    eventSmsIsraeliOnly: "SMS can only be sent to Israeli numbers (+972)",
    eventSmsSendTest: "Send test",
    eventSmsTestSuccess: "Test SMS sent",
    eventSmsTestUserNameLabel: "Test user name",
    eventSmsTestUserNameHelper: "Used to substitute %USER_NAME% in the test message",
    eventSmsTestUserNameRequired: "Test user name is required when the text uses %USER_NAME%",
    eventSmsTestDefaultsHelp: "In test mode %LINK_TO_TICKET% is replaced with https://selector.org.il. %EVENT_NAME% and %EVENT_DATE% come from this event.",

    organizerEventFeeMinError: "Events fee minimum percent is 0",
    organizerEventFeeMaxError: "Events fee maximum percent is 100",
    organizerEventFeeRequiredError: "Events fee percent is required",
    updateFeePercentError: "Get error when try to update organizer events fee",
    organizerSettingsEventFeePercentModalTitle: "Organizer Events Fee",
    organizerEventFee: "Events Fee",
    organizerUpdateEventFeeSettings: "Update Events Fee",

    organizerFilesModalTitle: "Organizer files",
    organizerFilesModalAddFile: "Upload new file",

    uploadNewOrganizerFileModalTitle: "Upload new organizer file",
    uploadNewOrganizerFileModalTitleDropOrClickFileHere:
      "Click or Drop file here",
    uploadNewOrganizerFileModalTitleDropFileHere: "Click or Drop file here",

    pdfFilePreview: "PDF File preview",

    // Admin Create Transaction Modal
    createTransactionModalTitle: "Create new transaction for organizer event",
    selectOrganizerEvent: "Select organizer event",
    eventNameSearchLabel: "Search by event name",
    selectTransactionType: "Select transaction type",
    transactionTypeService: "Service",
    transactionTypeSimple: "Transaction",
    selectOrganizerBillAccount: "Select organizer bill account",
    billAccountNameSearchLabel: "Search by bill account name",
    successTransactionCreateMessage: "Transaction successfully created",
    selectedEventName: "Selected event name:",
    totalEventAmount: "Total event amount",
    totalWithdrawnAmount: "Total withdrawn amount",
    availableForWithdrawalAmount: "Available for withdrawal amount",
    calculateData: "Calculate transaction data",
    totalTransactionAmount: "Total transaction amount",
    transactionAmount: "Transaction amount",
    transactionFeeAmount: "Transaction fee amount",
    fastWithdrawalFeeAmount: "Fast withdrawal fee amount",
    warningOverdraftAmount: "This transaction will cause an overdraft!",
    overdraftAfterTransaction: "Overdraft after transaction created",
    transactionAmountLabel: "Transaction Amount",
    transactionFeeAmountLabel: "Transaction Fee Amount",
    transactionAdminWithdrawalFeeAmountLabel: "Admin Withdrawal Fee Amount",
    amountRequiredError: "Amount is required",
    adminFeeRequiredError: "Admin withdrawal fee amount is required",
    numberMinError: "Value must be more than 0",
    transactionFastWithdrawalFeeAmountLabel: "Fast Withdrawal Fee Amount",
    transactionAdminNoteLabel: "Transaction Admin Note",
    overdraftConfirmation:
      "I understand that the transaction will be created in overdraft",
    transactionNameLabel: "Transaction Name",
    transactionNameRequiredError: "Transaction name is required",
    transactionNameMinError: "Transaction name is too short (min 3 characters)",
    formViewCreateButton: "Create Transaction",
    serviceFormViewCreateButton: "Create Service Transaction",
    gridEventTransactionListItemAdminWithdrawal: "Admin Withdrawal",
    gridEventTransactionListItemAdminFee: "Admin Withdrawal Fee",
    gridEventTransactionListItemOverdraft: "Overdraft 🚨",

    warningCancel:
      "The money from this event has been withdrawn or is in the process of being withdrawn.",
    warningCancelCheckbox: "I understand, cancel ticket(s)",

    otherRecipientLabel: "Create invoices to other user",
    recipientFullNameLabel: "User Full Name",
    recipientIdLabel: "User ID Code or Company ID",
    recipientPhoneLabel: "User Phone",
    recipientEmailLabel: "User Email",
    recipientFullNameRequiredError: "User Full Name is required",
    recipientIdRequiredError: "ID is required",
    phoneInvalidError: "User Phone is incorrect",
    phoneMinLengthError: "User Phone is incorrect",
    phoneMaxLengthError: "User Phone is incorrect",
    recipientPhoneRequiredError: "User Phone is required",
    emailInvalidError: "User Email is invalid",
    recipientEmailRequiredError: "User Email is required",

    // MARKETING PERSONS
    marketingPersonsTitle: "Marketing Persons",
    marketingPersonsAll: "All",
    marketingPersonsActive: "Active",
    marketingPersonsInactive: "Inactive",
    marketingPersonsAddPerson: "Add Person",
    marketingPersonsFind: "Search",
    marketingPersonsOrganizerSearch: "Search: name/surname, phone (+972...), or id:123",
    marketingPersonsPeriodStart: "Period Start",
    marketingPersonsPeriodEnd: "Period End",
    marketingPersonsDownloadAllExcel: "Download All Report (Excel)",
    marketingPersonsReportSummary: "Report Summary",
    marketingPersonsTotalTickets: "Total Tickets",
    marketingPersonsTotalAmount: "Total Amount",
    marketingPersonsTotalCommission: "Total Commission",
    marketingPersonsEventsCount: "Events Count",
    marketingPersonsTotalCount: "Total count:",
    marketingPersonsGridName: "Name",
    marketingPersonsGridPhone: "Phone",
    marketingPersonsGridIDcode: "Passport",
    marketingPersonsGridOrganizersCount: "Organizers",
    marketingPersonsGridStartDate: "Start Date",
    marketingPersonsGridEndDate: "End Date",
    marketingPersonsGridStatus: "Status",
    marketingPersonsGridActions: "Actions",
    marketingPersonsStatusActive: "Active",
    marketingPersonsStatusDisabled: "Disabled",
    marketingPersonsReport: "Report",
    marketingPersonsConfirmDeleteTitle: "Confirm Delete",
    marketingPersonsConfirmDeleteText: "Are you sure you want to remove this marketing person?",
    marketingPersonsConfirmAction: "Are you sure you want to perform this action?",
    marketingPersonsConfirmPaidTitle: "Confirm Status Change",
    marketingPersonsConfirm: "Confirm",
    marketingPersonsCancel: "Cancel",
    marketingPersonsDelete: "Delete",
    marketingPersonsAddTitle: "Add Marketing Person",
    marketingPersonsEditTitle: "Edit Marketing Person",
    marketingPersonsPhoneNumber: "Phone Number",
    marketingPersonsOrganizerId: "Organizer ID",
    marketingPersonsStartDate: "Start Date",
    marketingPersonsEndDate: "End Date",
    marketingPersonsDisabled: "Disabled (hidden)",
    marketingPersonsAdd: "Add",
    marketingPersonsSave: "Save",
    marketingPersonsAdding: "Adding...",
    marketingPersonsSaving: "Saving...",
    marketingPersonsSelectPerson: "Select Person",
    marketingPersonsComments: "Comments",
    marketingPersonsCommentsTitle: "Comments about organizer",
    marketingPersonsCommentPlaceholder: "Write a comment about this organizer…",
    marketingPersonsCommentAdd: "Add comment",
    marketingPersonsCommentsEmpty: "No comments yet",
    marketingPersonsCommentDeleteConfirm: "Delete this comment?",
    marketingPersonsUnbind: "Unbind organizer",
    marketingPersonsUnbindConfirm: "Unbind this organizer from the marketing person? Existing payouts are kept.",
    marketingPersonsAlreadyAssignedTitle: "Organizer is already assigned",
    marketingPersonsAlreadyAssignedText: "this organizer is already assigned to:",
    marketingPersonsAlreadyAssignedQuestion: "Do you really want to assign this organizer again?",
    marketingPersonsYes: "Yes",
    marketingPersonsNo: "No",
    marketingPersonsClose: "Close",
    marketingPersonsGridAssignments: "Assignments",
    marketingPersonsGridAssignmentsAll: "All",
    marketingPersonsGridAssignmentsActive: "Active",
    marketingPersonsGridAssignmentsFinished: "Finished",
    marketingPersonsUserFound: "User found",
    marketingPersonsUserCreatedNew: "New user created",
    marketingPersonsSearchOrganizer: "Search Organizer",
    marketingPersonsSearchNoResult: "Search failed",
    marketingPersonsAddAssignment: "Add Organizer Assignment",
    marketingPersonsClearPerson: "Clear",
    marketingPersonsTabPersons: "Persons",
    marketingPersonsTabAssignments: "Assignments",
    marketingPersonsAssignmentsAll: "All",
    marketingPersonsAssignmentsActive: "Active",
    marketingPersonsAssignmentsUnpaid: "Unpaid",
    marketingPersonsAssignmentsPaid: "Paid",
    marketingPersonsGridOrganizer: "Organizer",
    marketingPersonsGridCommission: "Commission",
    marketingPersonsGridCommissionType: "Commission Type",
    marketingPersonsGridCommissionValue: "Commission Value",
    marketingPersonsGridFee: "Fee",
    marketingPersonsGridPaid: "Payment",
    marketingPersonsPaid: "Paid",
    marketingPersonsTabReports: "Reports",
    marketingPersonsReportSearch: "Search by name or phone",
    marketingPersonsReportByOrganizer: "By Organizer",
    marketingPersonsReportByEvents: "By Events",
    marketingPersonsGridTotalFee: "Total Fee",
    marketingPersonsGridTotalCommission: "Commission",
    marketingPersonsGridWorkPeriod: "Work Period",
    marketingPersonsGridEventName: "Event",
    marketingPersonsGridEventDate: "Event Date",
    marketingPersonsGridOrganizerName: "Organizer",
    marketingPersonsReportNoData: "No report data. Set a period or search to load.",
    marketingPersonsSelectPeriod: "Select a date range for the Excel report (optional).",
    marketingPersonsTotalFee: "Total Fee",
    marketingPersonsSearch: "Search",
    marketingPersonsSearchHelper: "id:123 for ID, phone (+972...), or name/surname",
    marketingPersonsOrganizerSelected: "Selected",
    marketingPersonsAssignmentParams: "Assignment Parameters",
    marketingPersonsCommission: "Commission",
    marketingPersonsUnpaid: "Unpaid",
    marketingPersonsReferralPaid: "Referral Paid",
    marketingPersonsReferralUnpaid: "Referral Unpaid",
    marketingPersonsGridReferralPaid: "Referral Fee",
    marketingPersonsDetailsOpen: "Open",
    marketingPersonsDetailsTitle: "Marketing Person Details",
    marketingPersonsBackToList: "← Back to list",
    marketingPersonsDetailsOrganizersSection: "Organizers",
    marketingPersonsDetailsEventsSection: "Events",
    marketingPersonsOrganizerFilter: "Referral filter",
    marketingPersonsEventFilter: "Payment filter",
    marketingPersonsOrganizersCount: "Organizers",
    marketingPersonsPaidCommission: "Paid Commission",
    marketingPersonsUnpaidCommission: "Unpaid Commission",
    marketingPersonsPaymentsSection: "Payments",
    marketingPersonsPaymentAdd: "Add Payment",
    marketingPersonsPaymentAddTitle: "Add Payment",
    marketingPersonsPaymentKind: "Kind",
    marketingPersonsPaymentKindEvent: "Event",
    marketingPersonsPaymentKindOrganizer: "Organizer",
    marketingPersonsPaymentMonth: "Month",
    marketingPersonsPaymentAmount: "Amount (₪)",
    marketingPersonsPaymentNote: "Note",
    marketingPersonsPaymentPaidAt: "Paid At",
    marketingPersonsPaymentCreatedAt: "Created At",
    marketingPersonsPaymentDeleteTitle: "Delete Payment",
    marketingPersonsPaymentDeleteText: "This will remove the payment record. This action cannot be undone.",
    marketingPersonsPaymentMonthFrom: "Month From",
    marketingPersonsPaymentMonthTo: "Month To",
    marketingPersonsPaymentsReportTitle: "Payments Report",
    marketingPersonsPaymentsTotalCount: "Total payments",
    marketingPersonsPaymentsTotalAmount: "Total amount",
    headerOpenMarketingPayments: "Marketing Payments",
    marketingPersonsReferralCommission: "Referral Commission",
    marketingPersonsReferralCommissionHint: "One-time base amount paid for inviting this organizer",
    marketingPersonsPaymentKindReferral: "Referral",
    marketingPersonsClearFilters: "Clear filters",
    marketingPersonsCommissionBlockTitle: "Commission (Organizer & Event)",
    marketingPersonsReferralCommissionBlockTitle: "Referral Commission",
    marketingPersonsTotalReferralCommission: "Total Referral Commission",
    marketingPersonsPaidReferralCommission: "Paid Referral Commission",
    marketingPersonsUnpaidReferralCommission: "Unpaid Referral Commission",
  },
};
